module.exports = __webpack_public_path__ + "1c4f0ad70642f85461e965fc50b7f1a9.png";